import React, { useState, useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUsers, faSignInAlt, faTachometerAlt } from "@fortawesome/free-solid-svg-icons";
import "./GrievancePage.scss";

const GrievancePage: React.FC = () => {
  useEffect(() => {
    AOS.init({ duration: 1200 });
  }, []);

  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    const user = localStorage.getItem("token");
    if (user) setIsLoggedIn(true);
  }, []);

  return (
    <div className="grievance-page">
      <ToastContainer position="top-right" autoClose={3000} />

      {/* Header */}
      <div className="header" data-aos="fade-up">
        <h1>Grievance Redressal</h1>
        <p>Submit your grievance and our committee will review it promptly.</p>
      </div>

      {/* Dashboard Button or Login Button */}
      <div className="grievance-form" data-aos="fade-up">
        <h2>Welcome to Grievance Redressal</h2>
        {isLoggedIn ? (
          <div className="dashboard-section">
            <p>You are logged in. Go to the dashboard to manage grievances.</p>
            <a href="/dashboard" className="dashboard-btn">
              <FontAwesomeIcon icon={faTachometerAlt} /> Go to Dashboard
            </a>
          </div>
        ) : (
          <div className="login-section">
            <p>You must be logged in to access the grievance system.</p>
            <a href="/login" className="login-btn">
              <FontAwesomeIcon icon={faSignInAlt} /> Login
            </a>
          </div>
        )}
      </div>

      {/* Committee Details */}
      <div className="committee-section" data-aos="fade-up">
        <h2>Grievance Committee</h2>
        <div className="committee-card-container">
          {[
            { name: "Sri Shashidar Y R", role: "Chairman, Lecturer EC", phone: "9008214404" },
            { name: "Sri Kumar R", role: "Principal EC", phone: "9036447506" },
            { name: "Sri Kuberachari S H", role: "Lecturer EC", phone: "7406495888" },
            { name: "Sri Raju K", role: "Lecturer Science", phone: "9449414830" },
          ].map((member, index) => (
            <div className="committee-card" data-aos="zoom-in-up" key={index}>
              <FontAwesomeIcon icon={faUsers} size="2x" />
              <h3>{member.name}</h3>
              <p>{member.role}</p>
              <p>Phone: {member.phone}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default GrievancePage;